import React, { Component } from 'react';

class Message extends Component {
  render() {
    return (
      <div className="status-outline">
        <div className="usa-alert usa-alert-warning">
          <div className="usa-alert-body">
            <h3 className="usa-alert-heading">Please Note</h3>
            <p className="usa-alert-text">
              <b>{ this.props.message }</b>
            </p>
          </div>
        </div>
        <button onClick={ this.props.onMessageAck }>Continue</button>
      </div>
    );
  }
}

export default Message;



// WEBPACK FOOTER //
// ./src/Message.jsx